import Navbar from './Navbar';
import { Outlet } from 'react-router-dom';
const { version } = require('../../../package.json');

export default function AppLayout() {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Navbar />
<main className="flex-1 max-w-7xl mx-auto w-full px-4 py-6">
        <Outlet />
      </main>
      <footer className="border-t border-gray-200 py-3 text-center">
        <span className="text-xs text-gray-300">v{version}</span>
      </footer>
    </div>
  );
}
